export var ProductFeatureKeyEnum;
(function (ProductFeatureKeyEnum) {
    ProductFeatureKeyEnum["TRANSLATIONS"] = "TRANSLATIONS";
    ProductFeatureKeyEnum["MANAGE_ENVIRONMENTS"] = "MANAGE_ENVIRONMENTS";
    ProductFeatureKeyEnum["WEBHOOKS"] = "WEBHOOKS";
    ProductFeatureKeyEnum["AGENT_EMAIL_INTEGRATION"] = "AGENT_EMAIL_INTEGRATION";
})(ProductFeatureKeyEnum || (ProductFeatureKeyEnum = {}));
//# sourceMappingURL=billing.js.map